import { Bling as GPT, Events } from 'react-gpt';
import {middlewareWrapper} from "utils/middlewareUtils";
import { WINDOW_LOAD } from "../actions/windowEvents";
import config from "config";
import {isMobileApp} from "../../../utils/commonUtils";

export const LOAD_TAM_SCRIPT_SUCCESS = "LOAD_TAM_SCRIPT_SUCCESS";
export const TAM_SCRIPT_LOAD_ERROR = "TAM_SCRIPT_LOAD_ERROR";
export const TAM_SCRIPT_LOAD_TIMEOUT = "TAM_SCRIPT_LOAD_TIMEOUT";
export const TAM_SCRIPT_DISABLED = "TAM_SCRIPT_DISABLED";
export const INITIALIZE_TAM_SUCCESS = "INITIALIZE_TAM_SUCCESS";
export const UPDATE_ADVERT_SLOT = "UPDATE_ADVERT_SLOT";
export const ADVERT_BIDS_REQUESTED = "ADVERT_BIDS_REQUESTED";
export const ADVERT_BIDS_RECEIVED = "ADVERT_BIDS_RECEIVED";
export const LOAD_ADVERTS = "LOAD_ADVERTS";
export const GPT_FALLBACK_TIMER_ID = "GPT_FALLBACK_TIMER_ID";
export const CANCEL_GPT_FALLBACK_TIMER = "CANCEL_GPT_FALLBACK_TIMER";

export const initializeGptForTam = (documentFunction, configuration, gptApi) => (store, next, action) => {
  if (action.type === WINDOW_LOAD) {

    const { userAgent = null } = navigator;

    if ((!(configuration.tam && configuration.tam.enabled)) || isMobileApp(userAgent)){
      store.dispatch({type: TAM_SCRIPT_DISABLED});
      return next(action);
    }

    gptApi.disableInitialLoad();
    gptApi.enableSingleRequest();
    gptApi.collapseEmptyDivs();
    // enableServices is called internally by the react-gpt code.

    const forceDFPLoad = type => () => {
      store.dispatch({type});
      gptApi.refresh();
    };

    const resetAndRun = (timeoutId, toRun) => {
      if (timeoutID !== null) {
        clearTimeout(timeoutID);
        toRun();
      }
    };

    const doc = documentFunction();
    const scriptTag = doc.createElement("script");

    const timeoutID = setTimeout(forceDFPLoad(TAM_SCRIPT_LOAD_TIMEOUT), configuration.tam.scriptLoadTimeoutMs);

    // Handle Amazon script load errors. Fall back to GPT if it fails to load.
    scriptTag.addEventListener('error', () => {
      resetAndRun(timeoutID, forceDFPLoad(TAM_SCRIPT_LOAD_ERROR))
    });

    scriptTag.addEventListener('load', () =>
      resetAndRun(timeoutID, () => {
        store.dispatch({type: LOAD_TAM_SCRIPT_SUCCESS});
      })
    );

    scriptTag.async = true;
    scriptTag.src = configuration.tam.url;
    const head = doc.getElementsByTagName("head")[0];

    head.insertBefore(scriptTag, head.firstChild)
  }
  return next(action);
};

const getApstag = () => window.apstag;
const getDocument = () => document;

export const initializeTam = (configuration, apstagFn) => (store, next, action) => {
  if (action.type === LOAD_TAM_SCRIPT_SUCCESS) {
    apstagFn().init(configuration.tam.initializationParams);
    store.dispatch({type: INITIALIZE_TAM_SUCCESS});
  }

  return next(action);
};

export const gptFallbackTimer = (config, gptApi) => (store, next, action) => {
  if (action.type === LOAD_TAM_SCRIPT_SUCCESS) {
    const timeoutID = setTimeout(() => gptApi.refresh(), config.tam.bidRetreivalTimeoutMs);
    store.dispatch({type: GPT_FALLBACK_TIMER_ID, timeoutID})
  }

  if (action.type === CANCEL_GPT_FALLBACK_TIMER) {
    const {
      common: {
        tamGpt: {
          gptTimeoutId
        }
      } = {},
    } = store.getState();

    if (gptTimeoutId != null){
      clearTimeout(gptTimeoutId);
    }
  }

  return next(action);
};

export const fetchAdvertsForSlot = (apsTagFn, gptObject) => (store, next, action) => {
  if (action.type === LOAD_ADVERTS) {
    const sizeMappings = action.slotSize || (action.sizeMapping && action.sizeMapping.flatMap(size => size.slot));
    const slotId = action.slotId;
    const slotData = {
      slots: [{
        slotID: slotId,
        slotName: slotId,
        sizes: sizeMappings
      }]
    };

    if (sizeMappings === action.slotSize || (sizeMappings && sizeMappings.length > 0)) {
      const apsTag = apsTagFn();
      store.dispatch({type: UPDATE_ADVERT_SLOT, slotId: slotId, status: ADVERT_BIDS_REQUESTED});
      apsTag.fetchBids(slotData,
        bids => {
          store.dispatch({type: UPDATE_ADVERT_SLOT, slotId: slotId, status: ADVERT_BIDS_RECEIVED});
          console.log(`Bid callback for slot ${slotId}` + JSON.stringify(bids, null, "  "));

          const {
            common: {
              tamGpt: {
                advertSlots = {}
              }
            } = {},
          } = store.getState();

          gptObject.on(Events.READY, (adManager) => {
            adManager.cmd.push(
              () => {
                console.log(`Loading Bids for slot ${slotId}`);
                apsTag.setDisplayBids();
                if (allAdsRetrieved(advertSlots)){
                  store.dispatch({type: CANCEL_GPT_FALLBACK_TIMER});
                  console.log("Refreshing Advert components");
                  adManager.pubads().refresh();
                }
              }
            )
          });
        });
    }
  }
  return next(action);
};

const allAdsRetrieved = (advertSlots) => {
  return Object.values(advertSlots)
    .filter(status => status !== ADVERT_BIDS_RECEIVED)
    .length === 0;
};


export default () => {
  return [
    initializeGptForTam(getDocument, config, GPT),
    initializeTam(config, getApstag),
    fetchAdvertsForSlot(getApstag, GPT),
    gptFallbackTimer(config, GPT)
  ].map(middlewareWrapper);
}



// WEBPACK FOOTER //
// ./modules/Common/middleware/tamGptInitialization.js